import "./react-map.js";
import "./schoolRanking.js";
import "./faq.js";
import "./tabs.js";
import "./navigation.js";

//React components
import React, { render, useState, useEffect, createElement } from "react";
import ReactDOM from "react-dom";
import { Provider } from "mobx-react";
import iframes from "iframe-resizer";

//MobX Stores
import RootStore from "./stores/index";

//Wizard App
import WizardApp from "./jsx-components/wizard";

//Rules App
import RulesApp from "./jsx-components/rules";

//Auto Comp
import AutocompleteApp from './jsx-components/autocomplete';

//Setup Stores
const rootStore = new RootStore();

if(document.getElementById("pledge-frame")){
  iFrameResize({ log: false }, '#pledge-frame')
}

// //Wizard Application
if (document.getElementById("wizard-app")) {
  //let dataTarget = document.getElementById('body-main');
  ReactDOM.render(
    <Provider RootStore={rootStore}>
      <WizardApp />
    </Provider>,
    document.getElementById("wizard-app")
  );
}

// //Wizard Application
if (document.getElementById("rules-app")) {
  //let dataTarget = document.getElementById('body-main');
  ReactDOM.render(
    <Provider RootStore={rootStore}>
      <RulesApp />
    </Provider>,
    document.getElementById("rules-app")
  );
}

// //Autocomplete Application
if(document.getElementById('auto-comp')){
  ReactDOM.render(<Provider RootStore={rootStore}><AutocompleteApp/></Provider>, document.getElementById('auto-comp'));
}
